/**
 * Current constant include available type of element for styling
 * @const STYLABLE_ELEMENT
 * @type {object}
 * @param {string} INPUT=input.
 *   These states are available: [STYLABLE_ELEMENT_STATE.ERROR]{@link STYLABLE_ELEMENT_STATE}, [STYLABLE_ELEMENT_STATE.FOCUS]{@link STYLABLE_ELEMENT_STATE}.
 *   These styles are available [IElementStyleInput]{@link IElementStyleInput}
 * @param {string} SUBMIT_BUTTON=submit_button
 *   These states are available: [STYLABLE_ELEMENT_STATE.HOVER]{@link STYLABLE_ELEMENT_STATE}.
 *   These styles are available [IElementStyleSubmitButton]{@link IElementStyleSubmitButton}
 * @param {string} LABEL=label.
 *   These styles are available [IElementStyleLabel]{@link IElementStyleLabel}
 * @param {string} TITLE=title.
 *   These styles are available [IElementStyleTitle]{@link IElementStyleTitle}
 * @param {string} TITLE_DESCRIPTION=title_description.
 *   These styles are available [IElementStyleTitleDescription]{@link IElementStyleTitleDescription}
 * */
export const STYLABLE_ELEMENT = {
    INPUT: 'input',
    SUBMIT_BUTTON: 'submit_button',
    LABEL: 'label',
    TITLE: 'title',
    TITLE_DESCRIPTION: 'title_description',
};
/**
 * Current constant include available states of element for styling
 * @const STYLABLE_ELEMENT_STATE
 * @type {object}
 * @param {string} ERROR=error client|server validation. This state applies to: input
 * @param {string} FOCUS=focus focus. This state applies to: input
 * @param {string} HOVER=hover focus. This state applies to: submit_button
 * */
export const STYLABLE_ELEMENT_STATE = {
    ERROR: 'error',
    FOCUS: 'focus',
    HOVER: 'hover',
};
export const stylableElements = [
    {
        element: STYLABLE_ELEMENT.INPUT,
        states: [
            STYLABLE_ELEMENT_STATE.FOCUS,
            STYLABLE_ELEMENT_STATE.ERROR,
        ],
        styles: [
            'color',
            'border',
            'border_radius',
            'background_color',
            'height',
            'text_decoration',
            'font_size',
            'font_family',
            'line_height',
            'font_weight',
            'padding',
            'margin',
            'transition',
        ],
    },
    {
        element: STYLABLE_ELEMENT.SUBMIT_BUTTON,
        states: [
            STYLABLE_ELEMENT_STATE.HOVER,
        ],
        styles: [
            'color',
            'border',
            'border_radius',
            'background_color',
            'text_decoration',
            'font_size',
            'font_family',
            'line_height',
            'font_weight',
            'padding',
            'margin',
            'transition',
            'opacity',
        ],
    },
    {
        element: STYLABLE_ELEMENT.LABEL,
        states: [],
        styles: [
            'color',
            'text_decoration',
            'font_size',
            'font_family',
            'line_height',
            'font_weight',
            'padding',
            'margin',
        ],
    },
    {
        element: STYLABLE_ELEMENT.TITLE,
        states: [],
        styles: [
            'color',
            'text_decoration',
            'font_size',
            'font_family',
            'line_height',
            'font_weight',
            'padding',
            'margin',
            'text_align',
        ],
    },
    {
        element: STYLABLE_ELEMENT.TITLE_DESCRIPTION,
        states: [],
        styles: [
            'color',
            'text_decoration',
            'font_size',
            'font_family',
            'line_height',
            'font_weight',
            'padding',
            'margin',
            'text_align',
        ],
    },
];
/**
 * Interface for styling input element.
 * @interface IElementStyleInput
 *
 * @param {string} [color] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/color}
 * @param {string} [border] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/border}
 * @param {string} [border_radius] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-radius}
 * @param {string} [background_color] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/background-color}
 * @param {string} [height] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/height}
 * @param {string} [text_decoration] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration}
 * @param {string} [font_size] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-size}
 * @param {string} [font_family] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-family}
 * @param {string} [transition] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/transition}
 * @param {string} [line_height] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/line-height}
 * @param {string} [font_weight] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight}
 * @param {string} [padding] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/padding}
 * @param {string} [margin] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/margin}
 */
/**
 * Interface for styling submit_button element.
 * @interface IElementStyleSubmitButton
 *
 * @param {string} [color] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/color}
 * @param {string} [border] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/border}
 * @param {string} [border_radius] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-radius}
 * @param {string} [background_color] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/background-color}
 * @param {string} [text_decoration] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration}
 * @param {string} [font_size] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-size}
 * @param {string} [font_family] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-family}
 * @param {string} [padding] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/padding}
 * @param {string} [margin] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/margin}
 * @param {string} [transition] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/transition}
 * @param {string} [line_height] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/line-height}
 * @param {string} [font_weight] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight}
 * @param {string} [opacity] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/opacity}
 */
/**
 * Interface for styling label element.
 * @interface IElementStyleLabel
 *
 * @param {string} [color] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/color}
 * @param {string} [text_decoration] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration}
 * @param {string} [font_size] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-size}
 * @param {string} [font_family] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-family}
 * @param {string} [line_height] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/line-height}
 * @param {string} [font_weight] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight}
 * @param {string} [padding] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/padding}
 * @param {string} [margin] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/margin}
 */
/**
 * Interface for styling title element.
 * @interface IElementStyleTitle
 *
 * @param {string} [color] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/color}
 * @param {string} [text_decoration] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration}
 * @param {string} [font_size] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-size}
 * @param {string} [font_family] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-family}
 * @param {string} [line_height] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/line-height}
 * @param {string} [font_weight] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight}
 * @param {string} [padding] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/padding}
 * @param {string} [margin] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/margin}
 * @param {string} ['text-align',] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-align}
 */
/**
 * Interface for styling title_description element.
 * @interface IElementStyleTitleDescription
 *
 * @param {string} [color] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/color}
 * @param {string} [text_decoration] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration}
 * @param {string} [font_size] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-size}
 * @param {string} [font_family] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-family}
 * @param {string} [line_height] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/line-height}
 * @param {string} [font_weight] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight}
 * @param {string} [padding] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/padding}
 * @param {string} [margin] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/margin}
 * @param {string} ['text-align',] Look more [mozilla.org/color]{@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-align}
 */
//# sourceMappingURL=../../src/lib/widget/style.js.map